<!--
 * @Description: 描述
 * @Author: D
 * @Date: 2024-03-21 08:14
 * @LastEditTime: 2024-04-09 14:58
 * @LastEditors: D
 * @FilePath: \web\src\views\HomeView\Banner\index.vue
-->
<template>
  <div class="banner-container">
    <div class="banner-image">
      <el-carousel height="600px">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <el-image class="image" :src="item.webImg" fit="cover"></el-image>
        </el-carousel-item>
        <!-- <el-carousel-item v-for="item in bannerList" :key="item.id">
          <img class="image" src="item.webImg" alt="">
        </el-carousel-item> -->
      </el-carousel>
    </div>
  </div>
</template>

<script>
// 导入 api/banner中的方法
import { GetBannerList } from "@/api/Banner/index";
export default {
  name: "banner",
  data() {
    return {
      IMAGEUEL: process.env.VUE_APP_BASE_URL,
      // 分页
      pageInfo: {
        currentPage: 1,
        pageSize: 10,
      },
      // 存放banner数据
      bannerList: [],
    };
  },
  methods: {
    // 处理banner数据方法
    async handleBannerList() {
      let res = await GetBannerList({
        currentPage: this.pageInfo.currentPage,
        pageSize: this.pageInfo.pageSize,
        state: 1, //状态（1正常 2删除）
      });
      // console.log(res);
      if (res.code === 200) {
        //将请求到的banner数据存到bannerList中
        this.bannerList = res.pageInfo.list;
      } else {
        this.$message.error("数据获取失败，请重试");
      }
    },
  },
  //当组件初始化完毕自动执行以下mounted方法
  mounted() {
    // 调用处理banner数据函数
    this.handleBannerList();
  },
};
</script>

<style lang="less" scoped>
.banner-container {
  .banner-image {
    margin: 0 auto;
    // max-width: 1920px;
    min-width: 1200px;
    height: 600px;
    border-radius: 8px;
    overflow: hidden;

    .image {
      width: 1200px;
      height: 100%;
    }
  }
}
</style>